	<div class="h-screen pt-16 sm:pt-32 mx-auto">
		<edu-header></edu-header>
		<div class="max-w-screen-2xl mx-auto">
			<router-outlet (activate)="scrollTop()"></router-outlet>
		</div>
		<edu-footer></edu-footer>
	</div>
